import type { ReferenceElement } from "../IDElement";
import type { CertificateConfiguration } from "../reportConfigs/certificateConfiguration";
import type { Report } from "./report";

export type CertificateReport = Report & {
  report_configuration: CertificateConfiguration;
  data: {
    uek_modules: DisplayedElement[];
    technical_education: DisplayedElement[];
    project_details: ReportProjectDetails;
    first_signature: number;
    second_signature: number;
  };
};

export type DisplayedElement = ReferenceElement & {
  displayed: boolean;
};

export type ReportProjectDetails = {
  title: string;
  subject: ReportSubject[];
  total_archived_points: number | null;
  total_grade: "0" | "1" | "2" | "3" | null;
};

export type ReportSubject = ReferenceElement & {
  archived_points: number | null;
};

export const emptyDisplayElement: DisplayedElement = { displayed: true, reference: "" };
export const emptyReportSubject: ReportSubject = { archived_points: null, reference: "" };
